// dynamic menu on plp 
document.addEventListener('DOMContentLoaded', ()=>{
  let windowWidth = window.innerWidth;
  let mainMenu = document.querySelector('[main-menu]');
  let toggleHolder = document.querySelector('[data-menu-toggle-holder]');
  let allTogglebuttons = document.querySelector('[data-menu-toggle-holder]');
  let toggleButton = document.querySelector('[data-menu-toggle]')
  let allul = document.querySelectorAll('[main-menu] [data-ul]');
  let allListitems = document.querySelectorAll('[main-menu] [data-list-items]');
  let buttonIcon = document.querySelector('[data-toggle-icon]');
  let dataIdlength = 0;
  allListitems.forEach((listItem)=>{
    listItem.addEventListener('click',(e)=>{
      e.preventDefault();
      let anchor = e.target;
      let anchorHref = anchor.getAttribute('href');
      if (anchorHref != '#') {
         window.location.href = anchorHref;
         return false;
      }
      let linkText = anchor.textContent;
      let buttonText = document.querySelector('[data-toggle-text]');
      let listItem = e.currentTarget;
      let dataId = listItem.dataset.id;
      toggleButton.setAttribute('data-current-menu',`${dataId}`);
      let dataIdsplit = dataId.split('-')
      let dataIdlength = dataIdsplit.length;
      let submenu = document.querySelector(`[main-menu] [data-menu-level="${dataId}"]`);
      if (submenu) {
        hideAllulli();
        if (dataIdlength == '2') {
          showCurrentsubmenu(submenu)
          buttonIcon.classList.remove('hidden');
          let newButton = toggleButton.cloneNode(true);
          newButton.setAttribute('data-toggle-replicate', '')
          let textNode = newButton.querySelector('[data-toggle-text]');
          textNode.textContent = linkText;
          toggleHolder.append(newButton);
          let newButtonwidth = newButton.offsetWidth;
          if (windowWidth >= 990) {
            let newWidth = newButtonwidth + 14 + 34;
            mainMenu.style.gap = `39px`;
          } else {
            mainMenu.style.gap = `21px`;
          }
          newButton.addEventListener('click',()=>{
            buttonIcon.classList.add('hidden');
            let parentMenu = document.querySelector('[main-menu]');
            let parentMenuul = parentMenu.querySelectorAll('[data-ul]');
            let parentMenuli = parentMenu.querySelectorAll('[data-list-items]');
            parentMenuul.forEach((ul)=> {
              ul.classList.add('hidden')
            })
            parentMenuli.forEach((li)=> {
              li.classList.remove('hidden')
            })
            newButton.remove();
            if (windowWidth>=990) {
              mainMenu.style.gap = '34px';
            } else {
              mainMenu.style.gap = '16px';
            }
          })
        }
        if (dataIdlength == '3') {
          let firstTwoElements = dataIdsplit.slice(0, 2).join('-');
          let parentMenu = document.querySelector(`[data-menu-level="${firstTwoElements}"]`)
          parentMenu.classList.remove('hidden');
          showCurrentsubmenu(submenu)
          toggleButton.setAttribute('data-second-link',buttonText.textContent);
          let newButton = toggleButton.cloneNode(true);
          newButton.setAttribute('data-toggle-replicate', '')
          newButton.style.left = '28px';
          let textNode = newButton.querySelector('[data-toggle-text]');
          textNode.textContent = linkText;
          if (windowWidth>=990) {
            mainMenu.style.gap = '115px';
          } else {
            mainMenu.style.gap = '100px';
          }
          newButton.addEventListener('click',()=>{
            hideAllulli();
            let firstTwoElements = dataIdsplit.slice(0, 2).join('-');
            let parentMenu = document.querySelector(`[data-menu-level="${firstTwoElements}"]`);
            parentMenu.classList.remove('hidden');
            let parentMenuli = parentMenu.querySelectorAll('[data-list-items]')
            parentMenuli.forEach((li)=>{
              li.classList.remove('hidden')
            })
            dataIdlength = 2;
            newButton.remove();
            if (windowWidth>=990) {
              mainMenu.style.gap = '39px';
            } else {
              mainMenu.style.gap = '21px';
            }
          })
          toggleHolder.append(newButton)
        } 
      }
    })
  })

function hideAllulli() {
  allul.forEach((ul)=>{
    ul.classList.add('hidden')
  })
  allListitems.forEach((li)=>{
    li.classList.add('hidden')
  })
}
function showCurrentsubmenu(submenu) {
  submenu.classList.remove('hidden')
  let subMenuli = submenu.querySelectorAll('[data-list-items]');
  subMenuli.forEach((listItem)=> { 
    listItem.classList.remove('hidden')
  })
}
// end 

// remove words form product title
  // let productGrid = document.querySelector('[data-product-grid]');
  // let allGriditems = productGrid.querySelectorAll('[data-product-grid-title]');
  // allGriditems.forEach((gridItem) => {
  //   let titleText = gridItem.textContent;
  //   titleText = titleText.replace(/남성|여성/g, '');
  //   gridItem.textContent = titleText.trim();
  // });

})